import React, { useState, useEffect } from "react";
import RelatorioForm from "../../components/Relatorios/gerarGarantia";
import Relatorio from "../../components/Relatorios/relatorioGarantia";
import HistogramaForm from "../../components/Relatorios/gerarHistograma";
import RelatorioHistograma from "../../components/Relatorios/histogramaManutencao";
import { getHistograma } from "../../services/api_histograma";
import dataFormatada from "../../hooks/Date/dataFormatada";
import Swal from "sweetalert2";

const HistogramaPage = (props) => {
    const [showForm, setShowForm] = useState(true);
    const [showRelatorio, setShowRelatorio] = useState(false);
    const [filtro, setFiltro] = useState({});
    const [dadosRelatorio, setDadosRelatorio] = useState([]);
    const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loading) {
      Swal.fire({
        title: "Gerando relatório...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      Swal.close();
    }
  }, [loading]);

    
  
const handleGenerateRelatorio = async (filtro) => {
    try {
    setLoading(true);
      let body = {
        idEmpresa: filtro.empresa,
        idUnidade: filtro.unidade,
        idTipoAplicacao: filtro.tipoAplicacao,
        idAplicacao: filtro.id_aplicacao,
        idManutentor: filtro.id_pessoa,
        idSolicitante: filtro.id_user_gerou,
        dataInicial: filtro.dataInicial, 
        dataFinal: filtro.dataFinal
      }

      const dados = await getHistograma(body);
  
        console.log("eita:", dados);
  
        setFiltro({
          nomeEmpresa: filtro.nomeEmpresa,
          nomeUnidade: filtro.nomeUnidade,
          descricaoTipoAplicacao: filtro.descricaoTipoAplicacao,
          nomeManutentor: filtro.nomeManutentor,
          nomeSolicitante: filtro.nomeSolicitante, 
          dataInicial: dataFormatada(filtro.dataInicial),
          dataFinal: dataFormatada(filtro.dataFinal)
        
        });
        setDadosRelatorio(dados);
        setShowForm(false);
        setShowRelatorio(true);
        setLoading(false);

      //console.log(dados)
      
    } catch (error) {
      console.error("Erro ao gerar relatório:", error);
    }
  };
  
  
    return (
      <div>
        {showForm && (
          <HistogramaForm
            show={showForm}
            handleClose={() => setShowForm(false)}
            handleGenerate={handleGenerateRelatorio}
          />
        )}
        {showRelatorio && (
          <RelatorioHistograma
            filtro={filtro}
            dataHora={new Date().toLocaleString()}
            dados={dadosRelatorio}
            setShowForm={setShowForm} // Passa a função para mostrar o formulário
            setShowRelatorio={setShowRelatorio} // Passa a função para esconder o relatório
          />
        )}
      </div>
    );
};

export default HistogramaPage;
